import User from '@/models/User'
import axios from '@/backend'
import router from '@/router'
const state = {
  user: User.from(localStorage.localUser),
  loading: false,
  redirectPath: null
}

const getters = {
  currentUser (state) {
    return state.user
  },
  userLoading (state) {
    return state.loading
  }
}

const mutations = {
  login (state) {
    state.user = User.from(localStorage.localUser)
  },
  logout (state) {
    state.user = null
    delete localStorage.localUser
    delete localStorage.token
  },

  setUser (state, user) {
    state.user = User.from(localStorage.localUser)
  },

  setLoading (state, loading) {
    state.loading = loading
  },

  updateUserProperties (state, data) {
    Object.keys(data).forEach((item) => {
      state.user[item] = data[item]
    })
  },
  redirectToPath (state, redirectPath) {
    state.redirectPath = redirectPath
  }
}

const actions = {
  loadUser ({dispatch, commit}, payload) {
    commit('setLoading', true)
    if (payload === 'login') {
      axios.defaults.headers['Authorization'] = 'Bearer ' + localStorage.token
    }
    axios.get('/current_user')
      .then(function (response) {
        localStorage.localUser = JSON.stringify(response.data)
        commit('setLoading', false)
        if (payload === 'login') {
          commit('login')
          dispatch('pushToHome')
        } else {
          commit('setUser')
        }
      })
      .catch(e => { console.log(e) })
  },
  pushToHome () {
    if (state.redirectPath) {
      router.push(state.redirectPath)
    } else if (state.user.defaultMailboxId) {
      var id = state.user.defaultMailboxId
      router.push('/inboxes/' + id)
    } else {
      router.push('/boards')
    }
  },

  updateUser ({dispatch, commit, state}) {
    axios.put(`/users/${state.user.id}`, {
      user: state.user
    })
      .then(response => {
        dispatch('loadUser')
      })
      .catch(e => console.log(e))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/user.js